export default __webpack_public_path__ + "static/media/tapeTwoMobile.18c3468b.svg";